import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'


import api from '../services/api'
import { conferePermissao, paramsToObject, formToObject, populateForm, objectToQueryString } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)



const Tipo_Movimentacao = () => {

  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('S')
  const [enableEdit, setenableEdit] = useState('N')
  const [comboExt, setComboExt] = useState([
    { display: 'Sim', value: 'S' },
    { display: 'Não', value: 'N' }
  ])
  const [comboAtivo, setComboAtivo] = useState([
    { display: 'Sim', value: 'S' },
    { display: 'Não', value: 'N' }
  ])
  const [comboGera, setComboGera] = useState([
    { display: 'Sim', value: 'S' },
    { display: 'Não', value: 'N' }
  ])

  const columns = [
    { id: 'descricao', numeric: false, label: 'Descrição', align: 'left', minWidth: 200 },
    { id: 'ativos', numeric: false, label: 'Ativo', align: 'left', minWidth: 150 },
    { id: 'gera', numeric: false, label: 'Gera E-mail', align: 'left', minWidth: 150 },
    { id: 'externos', numeric: false, label: 'Externo', align: 'left', minWidth: 150 },
  ]

  useEffect(() => {
    const fetchData = async () => {
      let tela = 'Tipo Movimentações'
      let consulta = await api.getAcessos(tela, 'Consulta')
      if (consulta !== 'S') {
        swal.fire('Usuário sem acesso', 'Usuário sem acesso a essa tela!', 'warning')
          .then((result) => {
            if (result.value) {
              window.history.back()
            }
          })
      } else {
        swal.fire({
          html: <FrLoading text="Carregando..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        setComboGera([
          { display: 'Sim', value: 'S' },
          { display: 'Não', value: 'N' }
        ])

        setComboExt([
          { display: 'Sim', value: 'S' },
          { display: 'Não', value: 'N' }
        ])

        const urlParams = new URLSearchParams(window.location.search);
        let query = paramsToObject(urlParams)

        setFilter(query)
        populateForm(document.getElementById('searchForm'), query)

        swal.close()
        if (query.buscar === 'true') {
          let event = new Event('build');
          getData(event)
        }
      }
    }
    fetchData()
  }, [])


  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    // if (!isEmpty(queryObject)) {
    if (true) {
      queryObject.buscar = true
      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/suporte/tipo_movimentacao?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/tipo_movimentacao', { params: queryObject }).then(r => {
        setData(r.data)
        console.log(r.data)
        swal.close()
      })
    } else {
      swal.fire('Nenhum filtro informado!', 'Informe ao menos um filtro para realizar a busca.', 'warning')
    }
  }

  function clearForm(e) {
    e.preventDefault();
    console.log('limpa');
    window.history.replaceState({ filtered: false }, 'filter', '/suporte/tipo_movimentacao');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    console.log(auxValues)
    switch (e.target.name) {
      default: auxValues[e.target.name] = e.target.value;
    }
    console.log(auxValues)
    setFilter(auxValues);
  };


  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Tipo Movimentação</h3>
          <UserOptions />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrTextInput
                value={filter.descricao || ''}
                style={{ width: 280 }}
                name="descricao"
                id="descricao"
                color="#9c9595"
                label="Descrição"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />

              <FrSelect
                value={filter.gera_mail || ''}
                style={{ width: 170 }}
                name="gera_mail"
                id="gera_mail"
                label='Gera E-mail'
                data={comboGera}
                onChange={handleChange}

              />
              <FrSelect
                value={filter.externo || ''}
                style={{ width: 170 }}
                name="externo"
                id="externo"
                label='Externo'
                data={comboExt}
                onChange={handleChange}

              />

              <FrSelect
                value={filter.ativo || ''}
                style={{ width: 170 }}
                name="ativo"
                id="ativo"
                label='Ativo'
                data={comboAtivo}
                onChange={handleChange}
              />







            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <Link to="/suporte/tipo_movimentacao/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                    Novo Registro
                  </button>
                </Link>}
            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv">
          <FrTable regName="tipo_movimentacao" columns={columns} searched={filtered} codeName="pk_tmo" page={'Tipo_Movimentacao'} data={data} enableEdit={enableEdit} enableDel={'S'} />
        </div>
        <FooterDelphus />
      </div>
    </div>
  )

}

export default Tipo_Movimentacao;